import {Brick, registerBrick, Service} from 'olympe';

export default class FakeClosePR extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} frontendId
     * @param {function()} forwardEvent
     */
    update($, [frontendId], [forwardEvent]) {
        Service.publish('userService', ({frontendId: frontendId, openPrs: [], updatedPr: '019808b78bf7a75e9eff'}))
            .then(() => {
                forwardEvent();
            })
            .catch((e) => {
                console.error(`Error while calling the service userService ${e}`);
            });

    }
}

registerBrick('0198ccaaa797ce824424', FakeClosePR);
